import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Options.module.scss'

/**
 * The `Options`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Options = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.options, styles.options]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Options.displayName = 'Options'

/** @type {object} */
Options.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Options.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Options)
